import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, fill, outline, gradient }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M8.94014 7.39769C7.66014 2.66769 5.41014 0.287688 2.98014 1.18769C0.620141 2.05769 0.250141 7.8777 2.52014 14.2577C5.26014 21.9177 11.6201 31.0677 11.6201 31.0677C11.6201 31.0677 11.4701 16.7277 8.94014 7.39769Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M3.51988 13.4376C3.51988 13.4376 1.97988 7.49762 3.37988 5.78762C4.76988 4.08762 7.61988 7.70761 8.32988 18.3376"
        fill={`url(#${randomGradientId1})`}
      />
      <path
        d="M3.51992 13.4377C2.88992 11.6277 2.41992 9.74765 2.41992 7.76766C2.43992 7.26766 2.46992 6.75766 2.65992 6.23766C2.83992 5.74766 3.13992 5.09765 3.92992 4.93765C4.31992 4.87765 4.65992 4.99766 4.92992 5.14766C5.17992 5.31766 5.40992 5.49766 5.57992 5.70766C5.94992 6.10766 6.20992 6.54765 6.43992 6.99765C7.32992 8.79765 7.74992 10.6977 8.02992 12.6077C8.30992 14.5177 8.37992 16.4377 8.32992 18.3477C7.99992 16.4577 7.66992 14.5877 7.25992 12.7477C6.82992 10.9177 6.35992 9.07766 5.54992 7.45766C5.34992 7.05766 5.11992 6.66765 4.84992 6.36765C4.58992 6.03765 4.24992 5.84766 4.06992 5.87766C3.86992 5.86766 3.59992 6.17765 3.46992 6.54765C3.30992 6.91765 3.24992 7.36766 3.18992 7.81766C3.06992 9.62766 3.26992 11.5477 3.51992 13.4377Z"
        fill={outline}
      />
      <path
        d="M66.2601 7.39769C67.5401 2.66769 69.7901 0.287688 72.2201 1.18769C74.5801 2.05769 74.9501 7.8777 72.6801 14.2577C69.9401 21.9177 63.5801 31.0677 63.5801 31.0677C63.5801 31.0677 63.7401 16.7277 66.2601 7.39769Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M71.6801 13.4376C71.6801 13.4376 73.2201 7.49762 71.8201 5.78762C70.4301 4.08762 67.5801 7.70761 66.8701 18.3376"
        fill={`url(#${randomGradientId2})`}
      />
      <path
        d="M71.6801 13.4376C71.9301 11.5476 72.1401 9.63763 72.0001 7.80763C71.9501 7.35763 71.8801 6.90765 71.7201 6.53765C71.5901 6.16765 71.3201 5.85763 71.1201 5.86763C70.9401 5.84763 70.6001 6.02764 70.3401 6.35764C70.0701 6.65764 69.8401 7.04763 69.6401 7.44763C68.8201 9.06763 68.3501 10.9076 67.9301 12.7376C67.5301 14.5776 67.2001 16.4476 66.8601 18.3376C66.8101 16.4276 66.8801 14.5076 67.1601 12.5976C67.4401 10.6976 67.8701 8.78764 68.7501 6.98764C68.9901 6.54764 69.2501 6.10763 69.6101 5.69763C69.7801 5.48763 70.0101 5.30764 70.2601 5.13764C70.5401 4.98764 70.8701 4.86764 71.2601 4.92764C72.0501 5.08764 72.3501 5.73763 72.5301 6.22763C72.7201 6.74763 72.7501 7.25765 72.7701 7.75765C72.7801 9.74765 72.3001 11.6276 71.6801 13.4376Z"
        fill={outline}
      />
      <defs>
        <radialGradient
          id={randomGradientId1}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.32347 6.0937) rotate(161.679) scale(5.55184 11.8251)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
        <radialGradient
          id={randomGradientId2}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(67.7743 6.31107) rotate(18.3211) scale(5.55184 11.8251)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
      </defs>
    </g>
  )
}
